let mineRoutes = [
    { //地址管理
        path: '/mine/addressList',
        name: 'AddressList',
        component: () => import('@/views/mine/addressManage/AddressList.vue'),
        meta: {showTab: false}
    },
    { //地址添加
        path: '/mine/addressEdit',
        name: 'AddressEdit',
        component: ()=> import('@/views/mine/addressManage/AddressEdit.vue'),
        meta: {showTab: false}
    },
    { //关注品牌 以废弃）
        path: '/mine/attentionBrands',
        name: 'AttentionBrands',
        component: ()=> import('@/views/mine/AttentionBrands.vue'),
        meta: {showTab: false}
    },
    {  //我的收藏（以废弃）
        path: '/mine/myCollection',
        name: 'MyCollection',
        component: ()=> import('@/views/mine/MyCollection.vue'),
        meta: {showTab: false}
    },
    { //我的信息
        path: '/mine/userInfo',
        name: 'UserInfo',
        component: ()=> import('@/views/mine/UserInfo.vue'),
        meta: {showTab: false}
    },
    { //设置支付密码
        path: '/mine/setUserPay',
        name: 'SetUserPay',
        component: ()=> import('@/views/mine/SetUserPay.vue'),
        meta: {showTab: false}
    },
    { //账户与安全
        path: '/mine/accounts',
        name: 'Accounts',
        component: ()=> import('@/views/mine/Accounts.vue'),
        meta: {showTab: false}
    },
    {  //账户与安全
        path: '/mine/accounts/GetUserPhone',
        name: 'setUserPhone',
        component: ()=> import('@/views/mine/GetUserPhone.vue'),
        meta: {showTab: false}
    },
    {  //账户与安全
        path: '/mine/accounts/setPhone',
        name: 'SetPhone',
        component: ()=> import('@/views/mine/SetPhone.vue'),
        meta: {showTab: false}
    },
    {  //账户与安全
        path: '/mine/accounts/updatePassword',
        name: 'UpdatePassword',
        component: ()=> import('@/views/mine/UpdatePassword.vue'),
        meta: {showTab: false}
    },
    {  //语言设置
        path: '/mine/accounts/langSet',
        name: 'UpdatePassword',
        component: ()=> import('@/views/mine/LangSet.vue'),
        meta: {showTab: false}
    },
];

export default mineRoutes
